<script setup>
defineProps(['model'])
</script>

<template>
  <!-- Editorial Two Column Block -->
  <section class="block-spacing w-full">
    <div class=" container-fluid">
      <div class="flex flex-col items-center lg:flex-row lg:justify-center lg:items-start lg:gap-14 lg:max-w-[1210px] mx-auto">
        <!-- column one -->
        <div
          class="prose w-full max-w-177.5 lg:w-1/2"
        >
          <div v-html="convertH1ToH2(stripEmptyHeadings(model?.column1?.value))" />
          <slot name="body01" />
        </div>
        <!-- column two -->
        <div
          class="prose w-full max-w-177.5 lg:w-1/2"
        >
          <div v-html="convertH1ToH2(stripEmptyHeadings(model?.column2?.value))" />
          <slot name="body02" />
        </div>
      </div>
    </div>
  </section>
</template>
